import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ArticleCards() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-none">
              {t('article_section.title1')}
              <br />
              {t('article_section.title2')}
            </h2>
          </div>
          <span className="text-sm text-foreground-500">{t('article_section.subtitle')}</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link
            to="/artykul/kakobuy-sheet-poradnik"
            className="group block bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
          >
            <div className="aspect-[4/3] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20photography%20with%20an%20open%20notebook%20featuring%20handwritten%20notes%20next%20to%20a%20ceramic%20cup%20of%20tea%20on%20a%20warm%20oak%20desk%20surface%2C%20soft%20morning%20sunlight%20streaming%20through%20a%20nearby%20window%20creating%20gentle%20shadows%2C%20cozy%20productive%20atmosphere%20with%20natural%20wood%20tones%20and%20cream%20textiles%2C%20Scandinavian%20inspired%20home%20office%20aesthetic&width=600&height=450&seq=kg-art-card1-v2&orientation=landscape"
                alt={t('article.card1.title')}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                {t('article.card1.title')}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {t('article.card1.desc')}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap">
                {t('article.read_more_btn')}
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </div>
          </Link>

          <Link
            to="/poradnik-zakupowy-kakobuy"
            className="group block bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
          >
            <div className="aspect-[4/3] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20hands%20holding%20a%20smartphone%20displaying%20colorful%20product%20grid%20against%20a%20cozy%20cafe%20background%20with%20warm%20ambient%20lighting%2C%20modern%20digital%20shopping%20lifestyle%20aesthetic%2C%20soft%20bokeh%20effect%20on%20background%20elements%2C%20contemporary%20tech%20meets%20commerce%20visual%20with%20inviting%20warm%20atmosphere&width=600&height=450&seq=kg-art-card2-v2&orientation=landscape"
                alt={t('article.card2.title')}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                {t('article.card2.title')}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {t('article.card2.desc')}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap">
                {t('article.read_more_btn')}
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </div>
          </Link>

          <Link
            to="/bezpieczne-zakupy-kakobuy"
            className="group block bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
          >
            <div className="aspect-[4/3] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20conceptual%20photography%20of%20a%20brass%20padlock%20resting%20on%20a%20stack%20of%20neatly%20organized%20documents%20and%20receipts%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20side%20lighting%20creating%20gentle%20dimensional%20shadows%2C%20trust%20and%20security%20visual%20metaphor%20with%20warm%20golden%20brass%20tones%2C%20minimalist%20financial%20safety%20aesthetic&width=600&height=450&seq=kg-art-card3-v2&orientation=landscape"
                alt={t('article.card3.title')}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                {t('article.card3.title')}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {t('article.card3.desc')}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap">
                {t('article.read_more_btn')}
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}